import { useEffect } from "react";
import { useState } from "react";



const AddGradeStep = ({addStep, gradeSteps}) => {
     const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [order, setOrder] =  useState(gradeSteps.reduce((max, step) => Math.max(max, step.order), 0) + 1);
    const [baseGrade, setBaseGrade] =  useState(0);
    const addStepClicked = (e) => {
        e.preventDefault();
        if (!title  || !baseGrade) {
            alert("Please fill all fields");
            return;
        }
        addStep({
            _id: Math.random().toString(36).substring(2, 15),
            title,
            body,
            order: parseInt(order),
            baseGrade: parseInt(baseGrade)
        });
        setTitle("");
        setBody("");
        setBaseGrade(0);
        //setOrder(gradeSteps.reduce((max, step) => Math.max(max, step.order), 0) + 1);
    }
    useEffect(() => {
         if (!gradeSteps || gradeSteps.length === 0) {
            setOrder(1); // If no steps exist, start with order 1
            return;
        }
        // Reset order to the next available number
        setOrder(gradeSteps.reduce((max, step) => Math.max(max, step.order), 0) + 1);
    }, [gradeSteps]);
     
  return (
    <div>
         <div className="mt-2 d-flex flex-row gap-2">
            <span>%</span>
            <input
                type="number"
                title="Grade"
                value={baseGrade}
                onChange={(e) => setBaseGrade(e.target.value)}
                className="border p-1  w-20 mb-2"
                placeholder="Grade"
            />
            <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="border p-1 flex-1 mb-2"
                placeholder="Title"
            />
            {/* <textarea
                value={body}
                onChange={(e) => setBody(e.target.value)}
                className="border p-1 w-full mb-2"
                placeholder="Description"
            /> */}
          
            <input
                type="number"
                title="Order"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
                className="border p-1 w-16  mb-2"
                placeholder="Order"
            />
            <button
            className={`bg-blue-500 text-white px-4 h-10 rounded ${!title || !baseGrade ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={!title || !baseGrade}
            onClick={addStepClicked}
            >
                הוספה
            </button>
            </div>
            
    </div>
  )
}

export default AddGradeStep